import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Transition } from '@headlessui/react';
import useRandomId from 'hooks/useRandomId';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import MobileModal from 'components/consumer/MobileModal';
import MoveItButton from 'components/consumer/MoveItButton';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import IconJoybirdSymbol from 'components/icons/iconJoybirdSymbol';
import { colorBrand } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
const floatingModalRootElement = getOrCreateElementById('FloatingModal-root');
const FloatingModal = t0 => {
  const $ = _c(33);
  const {
    children,
    isOpen: t1,
    onClose,
    title
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const {
    isMobile
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("FloatingModal-title");
  let t2;
  if ($[0] !== onClose) {
    t2 = event => {
      if (event?.target?.tagName.toLowerCase() === "a" && event?.target?.getAttribute("target") !== "_blank") {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onContentClick = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-4"><IconJoybirdSymbol color={colorBrand} /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== modalTitleId || $[4] !== title) {
    t4 = title && <h2 className="text-xl font-bold text-gray mt-0 mx-0 mb-4" id={modalTitleId}>{title}</h2>;
    $[3] = modalTitleId;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = <div className="text-sm text-gray-light1 [&_a]:text-brand">{children}</div>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onContentClick || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="FloatingModal__inner-content" onClick={onContentClick}>{t3}{t4}{t5}</div>;
    $[8] = onContentClick;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const innerContent = t6;
  if (isMobile) {
    let t7;
    if ($[12] !== innerContent || $[13] !== isOpen || $[14] !== onClose) {
      t7 = <MobileModal {...{
        children: innerContent,
        isFullHeight: true,
        isOpen,
        onClose
      }} />;
      $[12] = innerContent;
      $[13] = isOpen;
      $[14] = onClose;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  let t7;
  if ($[16] !== onClose) {
    t7 = <div aria-hidden={true} className="FloatingModal__overlay" onClick={onClose} tabIndex="-1" />;
    $[16] = onClose;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <VisuallyHidden>Dialog content starts</VisuallyHidden>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onClose) {
    t9 = <MoveItButton className="absolute right-4 top-4" onClick={onClose} />;
    $[19] = onClose;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <VisuallyHidden>Dialog content ends</VisuallyHidden>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== innerContent || $[23] !== modalRef || $[24] !== modalTitleId || $[25] !== t9) {
    t11 = <div className="FloatingModal__content"><div ref={modalRef} role="dialog" aria-labelledby={modalTitleId}>{t8}{t9}{innerContent}{t10}</div></div>;
    $[22] = innerContent;
    $[23] = modalRef;
    $[24] = modalTitleId;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t7) {
    t12 = <div className="bottom-8 absolute right-8 w-[300px] min-h-[450px] max-h-[650px] overflow-x-auto rounded-lg shadow-[0_2px_10px_0#ccc] bg-white pt-[4.5rem] px-8 pb-8">{t7}{t11}</div>;
    $[27] = t11;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== isOpen || $[31] !== t12) {
    t13 = createPortal(<Transition show={isOpen} appear={true} enter="transition-opacity duration-150" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">{t12}</Transition>, floatingModalRootElement);
    $[30] = isOpen;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
FloatingModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string
};
export default withBrowserOnly(FloatingModal);